var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',[_c('div',{staticClass:"q-pa-md"},[_c('Breadcrumbs',{attrs:{"path-name":"purchase","path-method":"suggest"}}),_c('SuggestProduct',{attrs:{"is-local":false,"can-edit":_vm.loginUser.permission && _vm.loginUser.permission.Product > 2}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }